import { z } from "zod"

export const GenderEnum = z.enum(["male", "female", "other"], {
  message: "Geslacht is verplicht",
})

export const genderOptions: Array<{ label: string; value: Gender }> = [
  { label: "Man", value: "male" },
  { label: "Vrouw", value: "female" },
  { label: "X", value: "other" },
]

export const genderLabels: Record<Gender, string> = {
  male: "Man",
  female: "Vrouw",
  other: "X",
}

export type Gender = z.infer<typeof GenderEnum>
